module.exports = __webpack_public_path__ + "img/virtual_webinars.b38fae64.png";